declare namespace $ {

	type $shm_echarts__option_shm_hitalama_map_widget_float_echarts_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_echarts['option'] >
		,
		ReturnType< $shm_echarts['option'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_echarts_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_echarts_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_echarts['settings_add'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_echarts_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_widget_float_echarts_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_echarts['filter_name'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_widget_float_echarts_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_echarts['filter_add'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_list__sub_shm_hitalama_map_widget_float_echarts_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_echarts['filter_buttons'] >
		,
		ReturnType< $mol_list['sub'] >
	>
	type $mol_pop_over__align_shm_hitalama_map_widget_float_echarts_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pop_over['align'] >
	>
	type $mol_pop_over__Anchor_shm_hitalama_map_widget_float_echarts_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_echarts['Filters_add_anchor'] >
		,
		ReturnType< $mol_pop_over['Anchor'] >
	>
	type $mol_pop_over__bubble_content_shm_hitalama_map_widget_float_echarts_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pop_over['bubble_content'] >
	>
	export class $shm_hitalama_map_widget_float_echarts extends $shm_hitalama_map_widget_float {
		option( ): any
		Echarts( ): $shm_echarts
		settings_add( next?: any ): any
		Settings_add( ): $mol_button_minor
		Filters_add_anchor( ): $mol_button_minor
		filter_name( id: any): string
		filter_add( id: any, next?: any ): any
		Filter_add( id: any): $mol_button_minor
		filter_buttons( ): readonly(any)[]
		Filters( ): $mol_list
		Filters_add( ): $mol_pop_over
		controls( ): readonly(any)[]
		width_min( ): number
		height_min( ): number
		contextmenu_body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=echarts.view.tree.d.ts.map